export default "__VITE_ASSET__BadV6AJ8__"